import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Shimmer from 'react-shimmer-effect';
import { Form } from '@unform/web';

import { FaWhatsapp, FaLinkedinIn } from 'react-icons/fa';
import { MdMailOutline, MdSearch } from 'react-icons/md';

import giveahandLogo from '~/assets/logo.png';

import {
  Container,
  Header,
  RegisterLink,
  Content,
  Pagination,
  InputWrapper,
  SearchBox,
} from './styles';

import Footer from '~/components/Footer';
import LoadingLine from '~/components/LoadingLine';

import api from '~/services/api';

export default function Indications() {
  const [loading, setLoading] = useState(false);
  const [incidents, setIncidents] = useState([]);
  const [page, setPage] = useState(1);
  const [reg, setReg] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    document.title = 'Give A Hand | Indications';
  });

  useEffect(() => {
    async function loadIncidents() {
      try {
        setLoading(true);

        const response = await api.get('/indications', {
          params: {
            page,
            q,
          },
        });

        const { data } = response;

        setReg(response.headers['x-total-count']);

        setIncidents(data);
      } catch (error) {
        toast.error('Houve um erro ao tentar carregar uma idicação.');
      }

      setLoading(false);
    }

    loadIncidents();
  }, [page, q]);

  function sendWhatsApp(number, name) {
    const desiredNumber = number.replace(/[^\w]/gi, '');

    const win = window.open(
      `https://wa.me/55${desiredNumber}?text=Olá ${name}, quero te dar uma mãozinha 🤝 lhe indicando para uma oportunidade de emprego.`,
      '_blank'
    );
    win.focus();
  }

  function handleNextPage() {
    setPage(page + 1);
  }

  function handlePrevPage() {
    setPage(page - 1);
  }

  return (
    <Container>
      <Header>
        <div>
          <img src={giveahandLogo} alt="Give A Hand" />
        </div>

        <div>
          <RegisterLink to="/register">Criar cadastro</RegisterLink>
        </div>
      </Header>
      <Content>
        <div className="title-group">
          <h1>
            Lista pública de indicações{' '}
            <span>({reg} indicações cadastradas)</span>
          </h1>
          <p>
            Essa é um lista de <strong>contribuição pública</strong> de{' '}
            <strong>indicações de pessoas</strong> que estão precisando de{' '}
            <strong>realocação de emergência</strong> devido a crise da Covid-19
            em nosso país. Para dar <strong>aquela mãozinha</strong>, faça seu{' '}
            <Link to="/register">cadastro</Link> e aguarde que seu ID de login
            será enviando por e-mail após verificação dos dados.
          </p>
        </div>

        <SearchBox>
          <Form>
            <MdSearch size={30} color="#999" />
            <InputWrapper
              name="search"
              placeholder="Pesquisar por cargo"
              value={q}
              onChange={e => [setQ(e.target.value), setPage(1)]}
            />
          </Form>
        </SearchBox>

        <ul>
          {loading ? (
            <>
              <li>
                <Shimmer>
                  <LoadingLine />
                </Shimmer>
              </li>
              <li>
                <Shimmer>
                  <LoadingLine />
                </Shimmer>
              </li>
            </>
          ) : (
            incidents.map(item => (
              <li key={item.id}>
                <div className="info-group">
                  <div>
                    <strong>NOME:</strong>
                    <p>{item.indication_name}</p>
                  </div>

                  <div>
                    <strong>CARGO:</strong>
                    <p>{item.indication_position}</p>
                  </div>

                  <div>
                    <strong>CIDADE:</strong>
                    <p>
                      {item.indication_city !== null
                        ? item.indication_city
                        : 'Não informado'}
                    </p>
                  </div>

                  <div>
                    <strong>ESTADO:</strong>
                    <p>
                      {item.indication_state !== null
                        ? item.indication_state
                        : 'Não informado'}
                    </p>
                  </div>

                  <div>
                    <strong>CIDADE DE INTERESSE EM ATUAR:</strong>
                    <p>
                      {item.indication_city_interest !== null
                        ? item.indication_city_interest
                        : 'Não informado'}
                    </p>
                  </div>
                </div>

                <div className="button-group">
                  <strong>Entre em contato:</strong>
                  <div>
                    <button
                      type="button"
                      onClick={() =>
                        sendWhatsApp(
                          item.indication_whatsapp,
                          item.indication_name
                        )
                      }
                    >
                      <FaWhatsapp size={20} color="#FFF" />
                      WhatsApp
                    </button>

                    <a
                      href={`mailto:${item.indication_email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <MdMailOutline size={20} color="#FFF" />
                      E-mail
                    </a>

                    <a
                      href={`${item.indication_linkedin}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn size={20} color="#fff" /> LinkedIn
                    </a>
                  </div>
                </div>
              </li>
            ))
          )}
          {!incidents.length && !loading && (
            <li>
              Nenhuma indicação encontrada!{' '}
              <Link to="/indications/new">Cadastre agora mesmo.</Link>
            </li>
          )}
        </ul>
        <Pagination>
          <button type="button" onClick={handlePrevPage} disabled={page === 1}>
            Página anterior
          </button>
          <button
            type="button"
            onClick={handleNextPage}
            disabled={
              (page !== 1 && reg / 20 <= page) ||
              (page === 1 && incidents.length < 20) ||
              (q !== '' && reg === 20) ||
              reg === 20
            }
          >
            Próxima página
          </button>
        </Pagination>
      </Content>

      <Footer />
    </Container>
  );
}
